import { from } from "rxjs";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import { bulkP2PTransferMaxTemplateLine } from "./types.js";
import "exceljs";
import { CsvDocumentBuilder } from "../../file/services/CsvDocumentBuilder.js";
import "../../file/services/CsvDocumentBuilderAdapter.js";
import "../../file/services/FileDownloadService.js";
import { XlsxDocumentBuilder } from "../../file/services/XlsxDocumentBuilder.js";
class P2PTransferTemplateFactory {
  constructor(_xlsxBuilder = new XlsxDocumentBuilder(), _csvBuilder = new CsvDocumentBuilder()) {
    this._xlsxBuilder = _xlsxBuilder;
    this._csvBuilder = _csvBuilder;
  }
  parseFile(data) {
    const builder = this.getBuilder(data.file);
    const parseFileResult = builder.parseFile(data.file, this.getDataWorksheet().columns);
    return parseFileResult.resultObservable.pipe(
      map((parsedModels) => {
        return parsedModels.map((parsedModel) => {
          return { uid: parsedModel.uid, amount: Number(parsedModel.amount) };
        });
      })
    );
  }
  createFile() {
    this.setDataWorksheet();
    const document = this._xlsxBuilder.getDocument();
    return from(document.writeBuffer());
  }
  getBuilder(file) {
    const csvFileType = "csv";
    return file.name.endsWith(`.${csvFileType}`) ? this._csvBuilder : this._xlsxBuilder;
  }
  setDataWorksheet() {
    const dataWorksheet = this.getDataWorksheet();
    const worksheetKey = dataWorksheet.title;
    const worksheetColumns = Object.values(dataWorksheet.columns);
    this._xlsxBuilder.setWorksheet(worksheetKey);
    this._xlsxBuilder.setColumns(worksheetKey, worksheetColumns);
    this._xlsxBuilder.setHeaderStyles(worksheetKey);
    this._xlsxBuilder.setValidation(worksheetKey, worksheetColumns, bulkP2PTransferMaxTemplateLine);
  }
  getDataWorksheet() {
    const columns = {
      uid: { key: "uid", header: "UID", colIndex: 1 },
      amount: {
        key: "amount",
        header: "Amount",
        validation: {
          type: "decimal",
          operator: "greaterThan",
          formulae: [0],
          showErrorMessage: true,
          error: "Amount should be a number greater than 0",
          errorStyle: "error",
          errorTitle: "Amount is invalid"
        },
        colIndex: 2
      }
    };
    return {
      title: "P2P Transfers",
      columns
    };
  }
}
export {
  P2PTransferTemplateFactory
};
//# sourceMappingURL=P2PTransferTemplateFactory.js.map
